Barba.Dispatcher.on('transitionCompleted', function() {

  CSSPlugin.defaultTransformPerspective = 600;
  var toggleMenu = $('.main-nav__toggle');
  var toggleCollapse = $('.main-nav__collapse');
  var toggleDisplay = $('.display');
  var menuLinks = $('.main-nav__link');
  transitionAnimation = new TimelineMax({ paused: true, reversed: true });
        
  transitionAnimation
    // .set($el,{opacity:0, visibility:"visible"})
    // .to($el, 0.5,{opacity:1, ease:Power2.easeOut})
    // .from($(".navbar, .scroll-navbar"),1,{y:-96, ease:Expo.easeInOut}, 0.5)
    // .to(toggleDisplay,0.4,{opacity:0, ease:Power2.easeOut})
    .to(toggleCollapse,0.6,{x:0, ease:Power2.easeOut}, "-=0.4")
    .to(toggleMenu,0.6,{rotation:45, ease:Power2.easeOut}, "-=0.6");
    // .staggerFrom($("[data-transition-stagger-slow]"),1.5,{opacity:0, y:100, ease:Expo.easeOut}, 0.1, 0.5);

  toggleMenu.on('click', function() {
    $(this).toggleClass('on');
    transitionAnimation.reversed() ? transitionAnimation.play() : transitionAnimation.reverse();
  });

  menuLinks.on('click', function() {
    $(this).toggleClass('on');
    transitionAnimation.reversed() ? transitionAnimation.play() : transitionAnimation.reverse();
  });

  

  // $(".main-nav__link").each(function(){
  //   $(this).attr("data-barba-prevent", "self")
  // })

  var ua = navigator.userAgent || navigator.vendor || window.opera;
  var isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;

  if (document.documentElement.classList ){
      if (isInstagram) {
          window.document.body.classList.add('instagram-browser');
          // alert(window.innerHeight);
          if (window.screen.height < window.innerHeight) {
            document.querySelector(".hero").style.height = window.screen.height - 100 + "px";
          } else {
            document.querySelector(".hero").style.height = window.innerHeight + "px";
          }
      }
  }
});